function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const chart_id = document.querySelector("body").dataset.chartId;
	if (chart_id) {
		for (const li of document.querySelectorAll("#_chart_filters li")) {
			if (li.dataset.chartId === chart_id) {
				const button = li.closest(".btn-group").querySelector("button");
				if (button) {
					button.classList.add("active");
					button.textContent = li.textContent;
					break;
				}
			}
		}
	}
});
